import { useState } from 'react'
import { connect } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { StandardLaser } from './standardLaser'
import { StandardLaser2 } from './standardLaser1in2'
import { StandardLaser3 } from './standardLaser1in3'
import StandardThermal from './standardThermal'
function TicketPreview(props) {
  const [searchParams, setSearchParams] = useSearchParams()
  const [currentView, setCurrentView] = useState(searchParams.get('page') || '')
  const thermalParams = {
    logo: +searchParams.get('l'),
    helpline: +searchParams.get('h'),
    website: +searchParams.get('w'),
    delivery: +searchParams.get('dl'),
    declare: +searchParams.get('d'),
  }
  const { data } = props  
  const getPage = (key) => {
    let activityUI
    switch (key.toLocaleLowerCase()) {
      case 'laser1':
        activityUI = <StandardLaser delivery={+searchParams.get('dl')} />
        break
      case 'thermal':
        activityUI = <StandardThermal data={thermalParams} />
        break
      case 'laser3':
        activityUI = <StandardLaser2 delivery={+searchParams.get('dl')}/>
        break
      case 'laser4':
        activityUI = <StandardLaser3 delivery={+searchParams.get('dl')} />
        break
      default:
        activityUI = (
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', fontSize: '25px' }}>
            Coming Soon
          </div>
        )
        break
    }
    return activityUI
  }
  return <>{getPage(currentView)}</>
}
const mapStateToProps = (data) => ({ data })

const mapDispatchToProps = {}
export default connect(mapStateToProps, mapDispatchToProps)(TicketPreview)
